define('services/azurestorage',["require", "exports", "services/httpclient", "services/trace"], function (require, exports, http, trace) {
    "use strict";
    var AzureBlobUrl = (function () {
        function AzureBlobUrl() {
        }
        return AzureBlobUrl;
    }());
    var AzureStorage = (function () {
        function AzureStorage() {
        }
        AzureStorage.getBlobDownloadUrl = function (blobId, organizationId, fileName, contentDisposition) {
            var service = new http.Channel();
            var result;
            var actionUrl = "api/azurestorage/organizations/" + organizationId + "/downloads/blobs/" + blobId + "?fileName=" + fileName + "&contentDisposition=" + contentDisposition;
            service.getData(actionUrl, http.ServiceTarget.portalApi).then(function (data) {
                result = data;
            }).fail(function (reason) {
                var msg = (reason.responseJSON != null && reason.responseJSON.Message != null) ? reason.responseJSON.Message : "";
                trace.traceError("Error getting azure blob url. Please check the azure settings. " + msg, null, "getBlobDownloadUrl", true);
            });
            return result;
        };
        AzureStorage.getBlobUploadUrl = function (organizationId) {
            var service = new http.Channel();
            var result;
            service.postData("api/azurestorage/organizations/" + organizationId + "/uploads", http.ServiceTarget.portalApi, null).then(function (data) {
                result = data;
            }).fail(function (reason) {
                var msg = (reason.responseJSON != null && reason.responseJSON.Message != null) ? reason.responseJSON.Message : "";
                trace.traceError("Error getting azure blob url. Please check the azure settings. " + msg, null, "getBlobUploadUrl", true);
            });
            return result;
        };
        AzureStorage.useAzureStorage = function () {
            var service = new http.Channel();
            var result;
            service.getData("api/azurestorage/active", http.ServiceTarget.portalApi).then(function (data) {
                result = data;
            }).fail(function (reason) {
                var msg = (reason.responseJSON != null && reason.responseJSON.Message != null) ? reason.responseJSON.Message : "";
                trace.traceError("Error regarding the azure configuration. Please check the azure settings. " + msg, null, "useAzureStorage", true);
            });
            return result;
        };
        return AzureStorage;
    }());
    return AzureStorage;
});

